/* eslint-disable no-console,no-undef, camelcase, no-constant-condition */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  fetchApi,
} from "../../utils/methods";
import {  } from "../../utils/methods";
import { imageErrorMessage } from "../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer
} from "../CreateEvent/style";
import { Main } from "../AdminTeamCreation/styles";
// import Editor from "../CKEditor";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
// import CommonButton from "../common/CommonButton/CommonButton";
import { AddIconBranding, AdminCloseIcon, LaunchIcon, RecognitionCloseIcon, RecognitionBoldPencilIcon,RecognitionTickIcon, UploadHDMIcon } from "../../utils/icons";
import { AddCompanyExemplifiesValues, CreateCustomInitiative, GetInitiativescons } from "../../redux/constants/apiConstants";
import { Border } from "../Journeys/styles";
import { withRouter } from 'react-router-dom';
import { ImageUrl } from "../../utils/constants";
import { ButtonWrapper, CircleButton, ColorBox, ColorGrid, EditButton,Heading, IconGrid, InitiativeIconWrapper, ModalFooter, StyledModalV1, VerticalBorder } from "../RecogntionAdmin/corevalues/styles";
import { ManagerIconContainer } from "../Manager/styles";
import parse from 'react-html-parser';
import StepsHeading from "../RecogntionAdmin/corevalues/stepNames"; 
import { AdminIconContainer} from "../RecogntionAdmin/styles";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {CommonButtonPopup} from './styles'
import {CommonButtonBorder} from '../common/commonStyles'
import {ButtonCustom} from './styles'

class CreateHealthInitiative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      imageName: "",
      eventPointKey: null,
      eventPointValue: null,
      colorCode: null,
      //   status: props.history?.location?.state?.status,
      recognitionId: null,
      confirmIcon: null,        
      color: "",
      so: false,
      selectedOption:"",
      step: 1,
      buttonStatus: false,
      selectedColor: null,
      icon: null,
      // iconData:[],
      selectedIcon: null,
      showModal: false,
      showColorPicker: false,
      iconColor: null,
      disableButton: false,
      coreValueIcons: null,
      isModalOpen: false,
      selectedColorV1: null,
      confirmColorV1: null,
      initiativeLibraryIcons: [],
      selectedValueIcon: null,
      isPopupOpen: false,
      themeColor: null,
      pointsArray: [
        { value: "0", text: "0", id: '6' },
        { value: "25", text: "25", id: '1' },
        { value: "50", text: "50", id: '2' },
        { value: "100", text: "100", id: '3' },
        { value: "150", text: "150", id: '4' },
        { value: "200", text: "200", id: '5' },
        { value: "250", text: "250", id: '7' },
        { value: "300", text: "300", id: '8' },
        { value: "350", text: "350", id: '9' },
        { value: "400", text: "400", id: '10' },
        { value: "450", text: "450", id: '11' },
        { value: "500", text: "500", id: '12' },
        { value: "550", text: "550", id: '13' },
        { value: "600", text: "600", id: '14' },
        { value: "650", text: "650", id: '15' },
        { value: "700", text: "700", id: '16' },
        { value: "750", text: "750", id: '17' },
        { value: "800", text: "800", id: '18' },
        { value: "850", text: "850", id: '19' },
        { value: "900", text: "900", id: '20' },
        { value: "950", text: "950", id: '21' },
        { value: "1000", text: "1000", id: '22' }
      ],            
      colors: [
        { name: "Red", colorCode: "#F37A65", backgroundImage: "admin-recognition/Red.png" },
        { name: "Blue", colorCode: "#92A4DA", backgroundImage: "admin-recognition/Blue.png" },
        { name: "Maroon", colorCode: "#DA6C74", backgroundImage: "admin-recognition/Maroon.png" },
        { name: "Green", colorCode: "#75B084", backgroundImage: "admin-recognition/Green.png" },
        { name: "Orange", colorCode: "#DA9B6C", backgroundImage: "admin-recognition/Orange.png" },
        { name: "Purple", colorCode: "#BE7D9C", backgroundImage: "admin-recognition/Purple.png" },
        { name: "Yellow", colorCode: "#B1AA56", backgroundImage: "admin-recognition/Yellow.png" },
        { name: "Teal", colorCode: "#DA92C8", backgroundImage: "admin-recognition/Teal.png" },
      ],
      iconData: Array(50).fill({ icon: "AdminCloseIcon" })
    };
  }

  togglePopup = () => {
    this.setState((prevState) => ({ isModalOpen: !prevState.isModalOpen }));
  };


  toggleIconPopup = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  toggleColorPopup = () => {
    this.setState({ isModalOpen: false })
    this.setState((prevState) => ({ showColorPicker: !prevState.showColorPicker }));
  };

  handleModal = () => {
    this.setState({ isModalOpen: true })
  }

  handleCloseColorModal = () => {
    this.setState({ isModalOpen: false })
  }


  handleSelectedColor = () => {
    this.setState({ isModalOpen: false })
    this.setState({ selectedColorV1:this.state.confirmColorV1,themeColor: this.state.confirmColorV1?.colorCode, });
    
  }

  handleCloseModal = () => {
    this.setState({ showModal: false })
  }

  // onChangeColor = (e) => {
  //   this.setState({
  //     [e.target.name]: e.target.value,
  //   });
  // };


  onChangeColor = (e) => {
    this.setState({
      confirmColorV1: { colorCode: e.target.value }, // same format as colors array
    });
  };
  


  handleCloseColorPickerModal = () => {
    this.setState({ showColorPicker: false })
  }


  onSelectColor = (color) => {
    this.setState({ confirmColorV1: color });
    // this.setState({ confirmColorV1: color, themeColor:color?.colorCode });
  };


  // handleIconClick = (index, icon) => {
  //   this.setState({ selectedIcon: index, selectedValueIcon: icon });

  // };

  handleIconClick = (index, icon) => {
    this.setState({
      confirmIcon: icon,
      selectedIcon: index
    });
  };


  handleConfirmIcon = () => {
    this.setState({
      selectedValueIcon: this.state.confirmIcon, // set final value
      isModalOpen: false
    });
    this.handleCloseModal();
  };
  
  

  handleIconSelect = (icon) => {
    this.setState({ selectedIcon: icon, isModalOpen: false }); // Set selected icon and close modal
  };

  componentDidMount() {
    this.getInitiativesIcons();
  }

  onChange = (e) => {
    let file = e.target.files[0];
    let fileArr = e.target.files;
    if (e.target.files[0]) {
      if (checkImage(fileArr)) {
        if (file?.size / 1000000 <= 20) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          const array = document
            .getElementById("event-upload-file")
            .value.split("\\");
          reader.onloadend = () => {
            this.setState({
              imgSrc: reader.result,
              imageName: array[array.length - 1],
            });
            getOrientation(file, (or) => {
              resetOrientation([reader.result], or, (baseImage) => {
                this.setState({
                  imgSrc: baseImage,
                });
              });
            });
          };
        } else {
          toast.error("Please select image file less than 20MB");
          document.getElementById("event-upload-file").value = "";
        }
      } else {
        toast.error(imageErrorMessage);
        document.getElementById("event-upload-file").value = "";
      }
    }
  };


  backgroundColorName = [
    {
      id: 1,
      name: 'Light Pink',
      colorCode: "#F4AAA9"

    },
    {
      id: 2,
      name: 'Pink',
      colorCode: "#DC94B5"
    },
    {
      id: 3,
      name: 'Purple',
      colorCode: "#AF87C1"
    },
    {
      id: 4,
      name: 'Blue',
      colorCode: "#6781C3"
    },
    {
      id: 5,
      name: 'Sky Blue',
      colorCode: "#85C0EA"
    },
    {
      id: 6,
      name: 'Peacock Blue',
      colorCode: "#007AB1"
    },
    {
      id: 7,
      name: 'Dark Green',
      colorCode: "#006F88"
    },
    {
      id: 8,
      name: 'Green',
      colorCode: "#76AB78"
    },
    {
      id: 9,
      name: 'Yellow',
      colorCode: "#F1C977"
    },
    {
      id: 10,
      name: 'Orange',
      colorCode: "#FFBF73"
    },
  ];

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };

  onSelectPoints = (name) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventPointValue: name.value,
    });
  };


  onSelectColors = (name) => {
    this.setState({
      selectedColor: name
    });
  };

  submitInitiative = async () => {
    const { title, eventPointValue, description, selectedValueIcon, themeColor } = this.state
    const companyId = this.props.companyInfo?.id;
    const payload = {
      initiative_name: title,
      description: description,
      initiative_image: selectedValueIcon?.initiative_icon_orange_image,
      color: themeColor,
      points: eventPointValue,
      initiative_white_icon: selectedValueIcon?.initiative_icon_white_image,
    }
    try {
      const response = await fetchApi(CreateCustomInitiative + "/" + companyId, 'POST', payload);
      if (response.status === 'success') {
        toast.success(response.data[0]);
        this.props.history.push({pathname:"/company/health",state:"library"})
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };


  saveData = () => {
    const {
      title,
      description,
      eventPointValue,
      recognitionId,
      //   status
    } = this.state;
    const { companyInfo } = this.props;
    const RecognitionDetails = {
      company_id: companyInfo?.id,
      is_deleted: [],
      recognitions: [
        {
          core_value: title,
          description: description,
          id: recognitionId,
          point: eventPointValue,
          //   status: status
        }
      ]
    };

    this.PostRecognition(RecognitionDetails);
  };

  PostRecognition = async (payload) => {
    try {
      const res = await fetchApi(AddCompanyExemplifiesValues, "POST", payload);
      if (res?.data?.message) {
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
        });
      } else {
        toast.success(res.data[0]);
        this.props.history.push(`/company/recognition/addcorevalues`);
      }
    } catch (error) {
      toast.error(error)
    }
  }

  getInitiativesIcons = async () => {
    let apiUrl = GetInitiativescons;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        this.setState({ initiativeLibraryIcons: res.data })
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  handleOptionChange = (value) => {
    this.setState({selectedOption:value});
  };


  // onChangeDescription = (evt) => {
  //   const newContent = evt.getData();
  //   const tempDiv = document.createElement("div");
  //   tempDiv.innerHTML = newContent;
  //   const plainText = tempDiv.textContent || tempDiv.innerText || "";
  
  //   if (plainText.length > 300) {
  //     this.setState({ disableButton: true });
  //     return;
  //   }
  
  //   this.setState({ description: newContent, disableButton: false });
  // };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  nextStep = (value) => {
    this.setState({
      step: value,
      buttonClickScrollTop: true,
      buttonStatus: false,
    });
  };

  redirect = () => {
    this.props.history.push({pathname:"/company/health",state:"library"})
  };

  renderHeading = () => (
    <Heading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {this.props.t("Create Health Initiative")}
    </Heading>
  );

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };


  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };


  toggleColorPickerModal = () => {
    this.setState((prevState) => ({ showColorPicker: !prevState.showColorPicker }));
  };

  getLastSegmentAfterUnderscore(input) {
    // Get the filename
    const filename = input.split('/').pop(); // orange_social_wellness.png
  
    // Remove file extension
    const nameWithoutExtension = filename.replace(/\.[^/.]+$/, ""); // orange_social_wellness
  
    // Get part after last underscore
    const parts = nameWithoutExtension.split('_');
    if (parts.length < 2) return ""; // not enough underscores to extract
  
    // Join last parts (after the first word)
    const result = parts.slice(1).join(' '); // social wellness
    return result;
  }
  

  stepOneForm = () => {
    const {
      title,
      description,
      step,
      showModal,
      initiativeLibraryIcons,
      selectedValueIcon,
      themeColor,
    } = this.state;
    const { t } = this.props;
    return (
      <Layout>
        <div className="main" >
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="create-hdm-initiative" padding="20px 20px 265px 20px" />
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the health initiative")}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter text")}
                    name="title"
                    value={title}
                    maxLength="25"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61 !important"
                    onChange={this.onChangeInput}
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                  <div className="count">{title?.length}/25 | C</div>
                </InputContainer>

                <Border style={{ background: 'rgba(0, 92, 135, 0.10)', margin: '20px 0px' }} />
                <div style={{ display: "flex", width: "50%" }}>
                  <InputContainer width="auto" style={{ minWidth: "110px" }}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Background color")}</StyledLabel>
                    <ButtonWrapper isMargin={"14.5px"}>
                      {/* <CircleButton color={themeColor} onClick={this.togglePopup}>
                        <div>{themeColor? null:AddIconBranding(16, 16)}</div>
                      </CircleButton>
                      {themeColor && (
                        <EditButton onClick={this.togglePopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )} */}
                      <CircleButton color={this.state.selectedColorV1?.colorCode} onClick={this.togglePopup}>
                        <div>{this.state.selectedColorV1 ? null : AddIconBranding(16, 16)}</div>
                      </CircleButton>
                      {this.state.selectedColorV1 && (
                        <EditButton onClick={this.togglePopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )}
                    </ButtonWrapper>
                  </InputContainer>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                  }}>
                    <VerticalBorder />
                  </div>
                  <InputContainer style={{ minWidth: "28%" }}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Initiative icon")}</StyledLabel>
                    <ButtonWrapper isMargin={"7.5px"}>
                      {/* <CircleButton color={selectedValueIcon? themeColor: null} onClick={this.toggleIconPopup}>
                        {selectedValueIcon ? (
                          <div
                            style={{
                              position: 'absolute',
                              left: '28px',
                              top: '55%',
                              transform: 'translateY(-50%)',
                              width: '36px',
                              height: '36px',
                              pointerEvents: 'none',
                            }}> {themeColor? <img src={ImageUrl + "/" + selectedValueIcon?.initiative_icon_white_image} width={"24px"} height={"auto"} />:<img src={ImageUrl + "/" + selectedValueIcon?.initiative_icon_orange_image} width={"24px"} height={"auto"} />}</div>
                        ) : AddIconBranding(16, 16)}
                      </CircleButton> */}
                      <CircleButton color={selectedValueIcon ? themeColor : null} onClick={this.toggleIconPopup}>
                        {selectedValueIcon ? (
                          <div
                            style={{
                              position: 'absolute',
                              left: '28px',
                              top: '55%',
                              transform: 'translateY(-50%)',
                              width: '36px',
                              height: '36px',
                              pointerEvents: 'none',
                            }}>
                            {themeColor 
                              ? <img src={ImageUrl + "/" + selectedValueIcon?.initiative_icon_white_image} width={"24px"} height={"auto"} /> 
                              : <img src={ImageUrl + "/" + selectedValueIcon?.initiative_icon_orange_image} width={"24px"} height={"auto"} />}
                          </div>
                        ) : AddIconBranding(16, 16)}
                      </CircleButton>

                      {!this.state.selectedValueIcon?null: (
                        <EditButton onClick={this.toggleIconPopup}>
                          <div className="editIcon">{RecognitionBoldPencilIcon()}</div>
                        </EditButton>
                      )}
                    </ButtonWrapper>
                  </InputContainer>
                </div>
                <Border style={{ background: 'rgba(0, 92, 135, 0.10)', margin: '20px 0px' }} />

                <StyledModalV1 show={this.state.isModalOpen} onHide={this.handleCloseColorModal} width="800px" height="240px">
                  <div className="modal-content-padding">
                    <div className="header-wrapper">
                      <div className="heading">{t("Choose Background Color For Icon")}</div>
                      <div className="close-icon" onClick={this.handleCloseColorModal}>
                        {AdminCloseIcon()}
                      </div>
                    </div>
                    <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                    <ColorGrid>
                      {this.state.colors.map((color) => (
                        <ColorBox
                          key={color.colorCode}
                          style={{ background: color.colorCode }}
                          onClick={() => this.onSelectColor(color)}
                        />
                      ))}
                    </ColorGrid>
                    <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                    <ModalFooter isHeightButton="40px">
                      <ButtonCustom
                        isButtoHeight=""
                        isBg={true}
                        color="red"
                        hoverColor="#5a6268"
                        padding="12px"
                      >
                        <div style={{ position: 'absolute', width: '200px', height: '40px' }}>
                          <input
                            type="color"
                            name="themeColor"
                            onChange={this.onChangeColor}
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              opacity: 0,
                              zIndex: 1,
                              cursor: 'pointer',
                            }}
                          />  </div>
                        <AdminIconContainer isWidth={"16px"} isHeight={"16px"}>
                          {UploadHDMIcon()}
                        </AdminIconContainer>{" "}
                        Choose custom color
                      </ButtonCustom>
                      {/* <CommonButtonPopup 
                        background={themeColor?"#F37A65":"#EFEFEF"}
                        color={themeColor?"#FEFEFE":"#989898"}
                        onClick={themeColor? this.handleSelectedColor:null}>
                        {("Select Color")}{RecognitionTickIcon(themeColor?'white':"#989898")}
                      </CommonButtonPopup> */}
                      <CommonButtonPopup 
                        background={this.state.confirmColorV1 ? "#F37A65" : "#EFEFEF"} 
                        color={this.state.confirmColorV1 ? "#FEFEFE" : "#989898"} 
                        onClick={this.state.confirmColorV1 ? this.handleSelectedColor : null}
                      >
                        Select Color
                        {RecognitionTickIcon(this.state.confirmColorV1 ? "white" : "#989898")}
                      </CommonButtonPopup>
                    </ModalFooter>
                  </div>
                </StyledModalV1>
                {showModal && (
                  <StyledModalV1 isPadding={"0px 16px"} show={showModal} onHide={this.handleCloseModal} width="600px" height="424px">
                    <div className="modal-content-padding">
                      <div className="header-wrapper">
                        <div className="heading">{t("Choose Health Initiative Icon")}</div>
                        <div className="close-icon" onClick={this.handleCloseModal}>
                          {AdminCloseIcon()}
                        </div>
                      </div>
                      <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                      <IconGrid>
                        {initiativeLibraryIcons?.length > 0 ? (
                          this.state.initiativeLibraryIcons?.map((icon, index) => (
                            <InitiativeIconWrapper
                              key={index}
                              isSelected={this.state.selectedIcon === index}
                              onClick={() => this.handleIconClick(index, icon)}>
                              <img src={this.state.selectedIcon === index ? ImageUrl + "/" + icon?.initiative_icon_white_image : ImageUrl + "/" + icon?.initiative_icon_orange_image} />
                              <span className="tooltip-text">{this.getLastSegmentAfterUnderscore(icon?.initiative_icon_orange_image)  || "Icon"}</span>
                            </InitiativeIconWrapper>
                          ))
                        ) : (
                          <p>No icons available</p>
                        )}
                      </IconGrid>
                      <Border style={{ background: '#EFEFEF', margin: '16px 0px' }} />
                      <ModalFooter>
                        {/* <CommonButtonPopup background={selectedValueIcon?"#F37A65":"#EFEFEF"} color={selectedValueIcon?"#FEFEFE":"#989898"} 
                        onClick={selectedValueIcon? this.handleCloseModal:null}>
                          {("Select Icon")}{RecognitionTickIcon(selectedValueIcon?'white':"#989898")}
                        </CommonButtonPopup> */}

                        <CommonButtonPopup 
                          background={this.state.confirmIcon ? "#F37A65" : "#EFEFEF"} 
                          color={this.state.confirmIcon ? "#FEFEFE" : "#989898"} 
                          onClick={this.state.confirmIcon ? this.handleConfirmIcon : null}
                        >
                          Select Icon
                          {RecognitionTickIcon(this.state.confirmIcon ? 'white' : "#989898")}
                        </CommonButtonPopup>
                      </ModalFooter>
                    </div>
                  </StyledModalV1>
                )}
                {/* <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px'}}/> */}
                <InputContainer isColorError={parse(description)?.[0]?.props?.children?.[0]?.length > 300}>
                  <StyledLabel isFont={"14px"} style={{ marginTop: "0px" }} color={"#184A61"}>{this.props.t("About the health initiative")}</StyledLabel>
                  <EditorContainer>
                    <CKEditor
                      config={{
                        placeholder: "Write description here..."}}
                      editor={ClassicEditor}
                      data={this.state.description}
                      onReady={(editor) => {
                        this.editorInstance = editor;

                        editor.model.document.on('change:data', () => {
                          const plainText = editor.getData()
                            .replace(/<[^>]*>/g, '')
                            .replace(/&nbsp;/g, ' ')
                            .trim();

                          if (plainText.length > 300) {
                            const truncated = plainText.substring(0, 300);
                            editor.setData(truncated);
                          }

                          this.setState({
                            description: editor.getData(),
                            disableButton: plainText.length > 300,
                          });
                        });
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        this.setState({ description: data });
                      }}
                    />
                  </EditorContainer>
                  <div className="char-count">{parse(description)?.[0]?.props?.children?.[0]?.length || 0}/300 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepTwoForm = () => {
    const {
      step,
      eventPointValue,
      pointsArray,
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container isHeight="104px" color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="create-hdm-initiative" padding="20px 20px 265px 20px" />
            </div>
            <div className="form">
              <div className="formBody">
                <CommonDropdown
                  tileContainerStyle={{ width: "100%", padding: "0px 0px 20px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Health Initiative point ")}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select Point Value")}
                  title={
                    eventPointValue ? eventPointValue: +"No Points"
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={pointsArray}
                  onSelect={this.onSelectPoints}
                  active={eventPointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  dropIcon={true}
                />
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  render() {
    const {
      step,
      title,
      description,
      selectedValueIcon,
      eventPointValue,
      themeColor
    } = this.state;
    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2
            ? this.stepTwoForm()
            : null}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title || !description || !selectedValueIcon || !themeColor} onClick={!title || !description || !selectedValueIcon || !themeColor?null: () => this.updateStep(2)}>
                Next
                {!title || !description || !selectedValueIcon || !themeColor}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) :
          step === 2 && (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px" onClick={() => this.nextStep(1)} margin="auto auto auto 0px">
                 
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup margin="auto 0 auto auto" width="180px" height="48px" disabled={!eventPointValue} onClick={!eventPointValue ?null: () => this.submitInitiative()}>
                  Create Initiative{!eventPointValue? LaunchIcon("#989898"):LaunchIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          )}
      </React.Fragment>
    );
  }
}

CreateHealthInitiative.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  t: PropTypes.func,
  companyInfo: PropTypes.object
};

export default (withRouter(withTranslation()(CreateHealthInitiative)));
